<template>
    <section class="full-height-vh bg-white">
        <div class="pda-default">
            <!-- <div class="mgt-26 t-center">
                <router-link to="/login">
                    <img :src="brandLogo" class="login-logo">
                </router-link>
            </div> -->

            <div class="mgt-29 t-center t-headline3">
                {{$t('1519')}}
                <!-- 회원가입 -->
            </div>

            <div class="t-body3 t-color-content1 t-center mgt-25">
                <!-- {{$t('1520')}}<br>
                {{$t('1521')}} -->
                <!-- 하나의 계정으로 서비스를 이용하세요.<br>
                소셜 계정으로 이용하거나<br>
                이메일 계정을 만들 수 있습니다.<br> -->
            </div>

            <!-- <div v-if="!socialAuth">
                <div class="mgt-40 t-center">
                    <button class="mdc-button btn-sns-sign" @click.prevent="socialLoginAuth('google')">
                        <img src="https://aid-frontend.prod.atl-paas.net/atlassian-id/front-end/2.6.51/static/media/google-logo.c21ca9d1.svg">
                    </button>
                    <button class="mdc-button btn-sns-sign" @click.prevent="socialLoginAuth('facebook')">
                        <img src="https://upload.wikimedia.org/wikipedia/commons/c/c2/F_icon.svg">
                    </button>
                </div>                
                <hr class="divider-text mgt-40 t-body4 t-color-gray1" :data-content="$t('1522')">
            </div> -->

            <div class="mgt-40">
                <button class="mdc-button mdc-button--raised btn-red w-full btn-big" @click="createAcount">
                    {{$t('1523')}}
                    <!-- 계정 만들기 -->
                </button>
            </div>


            <div class="mgt-30 t-body4 t-color-content2">
                {{$t('1524')}}
                <!-- 가입한 계정이 있나요?  -->
                <router-link to="/login" class="t-color-red2">
                    {{$t('1525')}}
                    <!-- 로그인하기 -->
                </router-link>
            </div>

        </div>


        
    </section>
</template>

<script>
/**
 * 회원가입 - 인트로(sign up - intro component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import {MDCRipple} from '@material/ripple'
import firebase from 'firebase'
import { mapState, mapMutations } from 'vuex'
import loginApi from '@/api/loginApi.js'
import joinApi from '@/api/joinApi.js'
import brandApi from '@/api/brandApi.js'

export default {
    data() {
        return {
            socialType: '',
            socialToken: '',
            socialFirstName: '',
            socialLastName: '',
            socialFullName: '',
            socialEmail: '',
            brandLogo: localStorage.getItem('brandLogo'),
            socialAuth: false,
            
        }
    },
    created() {
        firebase.auth().onAuthStateChanged(function(user) {
            // if (user) {
            //     // User is signed in.
            // } else {
            //     // No user is signed in.
            // }        
        });
    },

    computed : {
        ...mapState('join',{
            join : state => state,
        })
    },

    mounted() {
        this.INIT_JOIN_STORE()
        this.SET_JOINSTART(true)

        // Whether to use social subscription
        brandApi.brandInfo().then((response) => {
            this.socialAuth = response.data.data.socialAuth
        })
    },

    methods: {
        // Store 변이 정의(define store mutation)
        ...mapMutations('join', [
            'SET_JOINSTART', 'SET_SOCIAL_LINK', 'SET_NAME_FIRST', 'SET_NAME_LAST', 'SET_NAME_FULL', 'SET_LOGINID', 'SET_SOCIAL_ID', 'INIT_JOIN_STORE'
        ]),

        // social login auth
        socialLoginAuth(socialType){
            let provider = null
            this.socialType = socialType

            if (socialType === 'google') {
                provider = new firebase.auth.GoogleAuthProvider()
            }else if (socialType === 'facebook') {
                provider = new firebase.auth.FacebookAuthProvider()
            }
            
            firebase.auth().signInWithPopup(provider).then((result) => {

                console.log('socialType');
                let providerUserInfo = null
                providerUserInfo = result.additionalUserInfo.profile
                console.log('providerUserInfo',providerUserInfo)
                
                if (socialType === 'google') {
                    this.socialFirstName =  providerUserInfo.family_name
                    this.socialLastName = providerUserInfo.given_name
                    this.socialFullName = providerUserInfo.name
                    this.socialEmail = providerUserInfo.email
                }else if (socialType === 'facebook') {
                    this.socialFirstName =  providerUserInfo.first_name
                    this.socialLastName = providerUserInfo.last_name
                    this.socialFullName = providerUserInfo.name
                    this.socialEmail = providerUserInfo.email
                }

                // get firebase user token
                firebase.auth().currentUser.getIdToken(true).then((idToken) => {
                    console.log('socialToken',idToken);
                    this.socialToken = idToken
                    
                    let params = {
                        type: 'firebase',
                        token: this.socialToken
                    }

                    // Duplicate check
                    joinApi.existsSocial(params).then((response) => {
                        // console.log('existsSocial', response.data.data);
                        if (response.data.data) { 
                            this.$router.push({name: 'Join2ExistSocial'})
                        }else {
                            this.SET_NAME_FIRST(this.socialFirstName)
                            this.SET_NAME_LAST(this.socialLastName)
                            this.SET_NAME_FULL(this.socialFullName)
                            
                            this.SET_SOCIAL_LINK({
                                type: 'firebase',
                                token: this.socialToken
                            })
                            this.SET_SOCIAL_ID(this.socialEmail)
                            this.SET_LOGINID(this.socialEmail)
                            this.$router.push({name: 'Join2Policy', query: {
                                type: 'social'
                            }})
                        }

                    }).catch((err) => {
                        
                    })
                }).catch((err) => {
                    
                })
                
            }).catch((err) => {
               if (err.email && err.credential && err.code === 'auth/account-exists-with-different-credential') {
                const providers = firebase.auth().fetchSignInMethodsForEmail(err.email)
                const firstPopupProviderMethod = providers.find(p => supportedPopupSignInMethods.includes(p));

                // Test: Could this happen with email link then trying social provider?
                if (!firstPopupProviderMethod) {
                    throw new Error(`Your account is linked to a provider that isn't supported.`);
                }

                const linkedProvider = getProvider(firstPopupProviderMethod);
                linkedProvider.setCustomParameters({ login_hint: err.email });

                const result = firebase.auth().signInWithPopup(linkedProvider);
                result.user.linkWithCredential(err.credential);
                }
            })
        },

        createAcount() {
            this.$router.push(
                'policy'
            )
        },


        // 로그인 API 파라미터 설정
        setParams(loginType) {
            let params = null

            params = {
                userId: '',
                password: '',
                device: {
                    type: 'WEB'
                },
                social: {
                    type: this.socialType,
                    token: this.socialToken
                }
            }
        
            return params
        },

        // callLoginApi(loginType) {
        //     let params = this.setParams(loginType)
        //     loginApi.login(params).then((response) => {
        //         this.$route.push({name: JoinExistSocial})
        //     }).catch((err) => {
        //         // console.log('회원가입 진행')
        //         this.$router.push({name: 'JoinExistSocial'})
        //     })
        // },

    }
}
</script>